<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="25rem"
  >
    <template v-slot:activator="{ on }">
      <v-btn small text v-on="on">
        <v-icon small left>
          fa-plus
        </v-icon>
        Ajouter un produit
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="addProduct">
          <v-autocomplete
            dense
            filled
            class="no-before"
            :items="getProducts.filter(x => x.data !== null)"
            item-value="id"
            item-text="nom"
            v-model="productId"
            label="Produit"
            required
          >
            <template v-slot:selection="data">
              <span class="text-capitalize">{{ data.item.nom }}</span>
            </template>
            <template v-slot:item="data">
              <span class="text-capitalize">{{ data.item.nom }}</span>
            </template>
          </v-autocomplete>
          <j-decimal-input
            dense
            filled
            class="no-before"
            v-model="index"
            label="Position"
            required
            :min="0"
            step="1"
          ></j-decimal-input>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row align="center" justify="end" dense no-gutters>
          <v-btn
            :disabled="valid === false"
            small
            color="success"
            @click="addProduct"
          >
            Ajouter
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
export default {
  name: "InventoryTemplateEditorProductAdder",
  props: {
    tags: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getRecipes"])
  },
  data() {
    return {
      productId: undefined,
      index: 0,
      dialog: false,
      valid: false
    };
  },
  methods: {
    async addProduct() {
      this.$refs.form.validate();
      if (this.valid === true) {
        const product = this.getProducts.find(x => x.id === this.productId);
        let tags = product.data.tags;
        this.tags.forEach(t => tags.push(t));
        if (product.est_intermediaire === true) {
          const recipe = this.getRecipes.find(
            x => x.fk_produit_intermediaire === this.productId
          );
          if (recipe && recipe.data !== null) {
            await api.patchRecipeTags(recipe.data.id, {
              id: recipe.data.id,
              tags: tags
            });
          }
        }
        await api.patchProductTags(product.data.id, {
          id: product.data.id,
          tags: tags
        });
        this.$emit("add-product", {
          product: this.getProducts.find(x => x.id === this.productId),
          index: this.index
        });
        this.dialog = false;
      }
    }
  }
};
</script>

<style></style>
